import type { CSSProperties, ReactNode } from 'react';
import styles from './ListPageLayout.module.css';

interface ListPageLayoutProps {
	children: ReactNode;
	sidebar: ReactNode;
	sidebarWidth?: string;
	sidebarW1500?: string;
	sidebarW1300?: string;
	sidebarW1200?: string;
	stackAt?: 1100 | 1124;
}

interface ListPageChartsProps {
	children: ReactNode;
	single?: boolean;
}

interface ListPageChartCardProps {
	children: ReactNode;
	maxHeight?: string;
	isFetching?: boolean;
}

export function ListPageLayout({
	children,
	sidebar,
	sidebarWidth = '24rem',
	sidebarW1500 = '20rem',
	sidebarW1300 = '17rem',
	sidebarW1200 = '15rem',
	stackAt = 1124,
}: Readonly<ListPageLayoutProps>) {
	const stackClass = stackAt === 1100 ? styles.stack1100 : styles.stack1124;

	return (
		<div
			className={`${styles.page} ${stackClass}`}
			style={
				{
					'--lpl-sw': sidebarWidth,
					'--lpl-sw1500': sidebarW1500,
					'--lpl-sw1300': sidebarW1300,
					'--lpl-sw1200': sidebarW1200,
				} as CSSProperties
			}
		>
			<div className={styles.mainContent}>{children}</div>
			<aside className={styles.sidebar}>{sidebar}</aside>
		</div>
	);
}

export function ListPageCharts({ children, single }: Readonly<ListPageChartsProps>) {
	return (
		<div className={`${styles.charts}${single ? ' ' + styles.single : ''}`}>{children}</div>
	);
}

export function ListPageChartCard({
	children,
	maxHeight,
	isFetching = false,
}: Readonly<ListPageChartCardProps>) {
	return (
		<div
			className={styles.chartCard}
			style={maxHeight ? { maxHeight } : undefined}
			aria-busy={isFetching}
		>
			{children}
			{isFetching && (
				<span role="status" className={styles.refreshStatus}>
					Atualizando estatísticas…
				</span>
			)}
		</div>
	);
}
